import React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../contexts/SubscriptionContext';

export default function SubscriptionGate({ featureKey, children }) {
  const { hasFeature, planLabel } = useSubscription();
  const navigate = useNavigate();

  if (hasFeature(featureKey)) {
    return children;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <Paper
        elevation={3}
        sx={{
          maxWidth: 560,
          width: '100%',
          borderRadius: 3,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Funkcja niedostepna w planie {planLabel}
        </Typography>
        <Typography sx={{ color: '#5f6b7a', mb: 3 }}>
          To jest testowy paywall. Docelowo tutaj bedzie podpiecie do Stripe i aktywnej subskrypcji.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/#price')}
          sx={{
            textTransform: 'none',
            borderRadius: 999,
            px: 3,
            py: 1.2,
            background: 'linear-gradient(135deg, #2f7fa2, #356fb4)',
          }}
        >
          Zobacz plany
        </Button>
      </Paper>
    </div>
  );
}
